import { EventEmitter } from "@angular/core";

export class IncorporadoraHeaderService{

    incorporadoraChanged = new EventEmitter<any>();
    
    incorporadoraNovaAdicionada(){
        this.incorporadoraChanged.emit(true);
    }

}


// WEBPACK FOOTER //
// ./src/services/incorporadora-header.service.ts